"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query listStripeTerminalReaders {
    listStripeTerminalReaders {
      id
      label
      type
      location
      serialNumber
      status
      ipAddress
    }
  }
`;
exports.default = query;
//# sourceMappingURL=listStripeTerminalReaders.query.js.map